import { parseDate, parseNumber, parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'
import { RolodexEntryJson } from './rolodexEntryFields'

/**
 * An entry which represents a visual inspection form configuration.
 * Defines the overall structure and metadata for a form that Pylon will use
 * to generate inspection forms in the field.
 */
export class GeckoVisualInspectionForm extends GeckoEntryBase<
  {
    form_type: string
    description?: string
    version: number
    created_date: Date
    last_modified_date: Date
  },
  {
    organization: string
    site: string
  },
  Record<string, never>
> {
  /**
   * A simple constructor, private so that a more descriptive factory method
   * (which can return undefined) is used instead
   * @param json The raw JSON to create an instance from
   * @private
   */
  private constructor(json: RolodexEntryJson) {
    super(
      json,
      {
        form_type: parseString(json.data.form_type) ?? '',
        description: parseString(json.data.description),
        version: parseNumber(json.data.version) ?? 1,
        created_date: parseDate(json.data.created_date) ?? new Date(),
        last_modified_date:
          parseDate(json.data.last_modified_date) ?? new Date(),
      },
      {
        organization: parseString(json.tags.organization) ?? '',
        site: parseString(json.tags.site) ?? '',
      },
      {}
    )
  }

  /**
   * A simple factory method which creates a visual inspection form from raw JSON
   * @param json The raw JSON to create an instance from
   * @constructor
   */
  public static CreateFromJSON(json: RolodexEntryJson) {
    return new GeckoVisualInspectionForm(json)
  }
}
